<article id="social-push-log-delete" style="text-align: center" class="admin-dialog">
  <header style="font-size: 20px; line-height: 24px; font-weight: 500">Delete Push</header>
  <section style="margin-top: 12px">Are you sure you want to delete this story?</section>
  <section style="display: flex; justify-content: center; margin-top: 26px; gap: 10px">
    <div class="btn-white" (click)="onNoClick()" style="width: 80px; height: 36px">Cancel</div>
    <div class="btn-black" (click)="onConfirm()" style="width: 80px">Delete</div>
  </section>
</article>
